// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"3eee4eec","580":"c88c1521"}[chunkId] + ".chunk.css";
};